import React from 'react';
import { AlertCircle, ClipboardCheck } from 'lucide-react';

// A5: profil sayfasındaki inceleme durumu bantları. Veri sunucunun sahip görünümünden gelir (`review_state`);
// yayın/onay kararını sunucu verir, bu bileşen yalnız açıklar.
export const reviewBand = state => {
  if (!state) return null;
  const pending = state.pending;
  const reason = pending?.reason || state.last_decision?.reason || '';
  if (pending?.kind === 'critical' && pending.status === 'changes_requested')
    return { tone: 'warn', id: 'critical-changes', title: 'Değişikliğin için düzeltme istendi',
      text: `${reason ? reason + ' ' : ''}Onaylanana kadar mevcut bilgilerin görünmeye devam ediyor.`, action: true };
  if (pending?.kind === 'critical' && pending.completion && pending.status === 'pending')
    return { tone: 'info', id: 'completion-pending', title: 'İncelemede',
      text: 'Eklediğin bilgiler ekibimize ulaştı. Onaylanınca profilin keşifte görünür.' };
  if (pending?.kind === 'critical')
    return { tone: 'info', id: 'critical-pending', title: 'Değişikliğin incelemede', sep: ';',
      text: `onaylanana kadar mevcut bilgilerin görünür.${pending.changed_fields?.length ? ' Bekleyen: ' + pending.changed_fields.map(f => f.label).join(', ') + '.' : ''}` };
  if (!state.approved && state.profile_status === 'changes_requested')
    return { tone: 'warn', id: 'changes-requested',
      title: state.last_decision?.decision === 'reject' ? 'Profilin onaylanmadı' : 'Düzeltme istendi',
      text: `${reason ? reason + ' ' : ''}Meko ile kaldığın yerden tamamlayıp yeniden gönderebilirsin.`, action: true };
  if (!state.approved && state.profile_status === 'pending_review')
    return { tone: 'info', id: 'in-review', title: 'İncelemede', text: 'Profilin ekibimize ulaştı. Onaylanınca keşifte görünür.' };
  if (state.approved && state.missing?.length)
    return { tone: 'warn', id: 'missing-core', title: 'Profilin keşifte görünmesi için şu bilgiler eksik',
      text: state.missing.map(m => m.label).join(', ') + '.', action: true };
  if (state.approved && state.last_decision?.kind === 'critical' && state.last_decision.decision === 'reject')
    return { tone: 'info', id: 'critical-rejected', title: 'Son değişikliğin onaylanmadı',
      text: `${reason ? reason + ' ' : ''}Mevcut onaylı bilgilerin aynen görünüyor.` };
  return null;
};

export default function ProfileReviewBand({ state, onComplete }) {
  const band = reviewBand(state);
  if (!band) return null;
  const Icon = band.tone === 'warn' ? AlertCircle : ClipboardCheck;
  return <div className="home-notice dna-band profile-review-band" role="status" data-testid={`profile-review-${band.id}`}>
    <Icon size={18} aria-hidden="true" />
    <p><strong>{band.title}{band.sep || ':'}</strong> {band.text}</p>
    {band.action && onComplete && <button type="button" className="action-secondary" onClick={onComplete} data-testid="profile-review-complete">Meko ile tamamla</button>}
  </div>;
}
